import { render, staticRenderFns } from "./PatientPersonalDataForm.vue?vue&type=template&id=0e56318f&"
import script from "./PatientPersonalDataForm.vue?vue&type=script&lang=js&"
export * from "./PatientPersonalDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports